import React, { useEffect } from "react";

import { useCustomerPortalContext } from "Context/CustomerPortalContext";
import { useAppState } from "Context/StateContext";
import { useSecretManager } from "Hooks/useSecretManager";
import { useHistory } from "react-router-dom";
import env from "Util/env";
import { setWindowLocationWithTokenCustomerPortal } from "Util/setWindowLocationWithTokenCustomerPortal";

import { CustomerPortalLoadingPortalSentences } from "../CustomerPortalLoadingPortal";
import { BorderLinearProgress, BoxContainer, Container } from "./styles";

export const CustomerPortalRedirectToDetails: React.FC = () => {
  const { secret } = useSecretManager(env.SECRET_ID);
  const { currentCustomerUser } = useAppState();
  const { ordersAssociated } = useCustomerPortalContext();
  const history = useHistory();

  useEffect(() => {
    const firstOrder = (ordersAssociated || [])?.[0];

    if (firstOrder && firstOrder.id) {
      setWindowLocationWithTokenCustomerPortal(
        history,
        {
          jobId: firstOrder.id,
          companyId: currentCustomerUser?.companyId!,
          customerId: currentCustomerUser?.customerId!,
        },
        secret
      );
    }
  }, [history, ordersAssociated, secret]);

  return (
    <Container>
      <BoxContainer>
        <BorderLinearProgress />
      </BoxContainer>
      <CustomerPortalLoadingPortalSentences />
    </Container>
  );
};
